/**
 * Home Page
 *
 * Main application page with editor layout
 */

import { MainLayout } from '@/components/layout/MainLayout';

export const HomePage: React.FC = () => {
  return <MainLayout />;
};
